import {
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SelfDisclosureQuestion } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioSelect } from '@immomio/ui/select';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { PhoneInputComponent } from '../../../components/molecules/form/controls/phone-input/phone-input.component';
import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';
import { SelfDisclosureUniqueFieldsService } from '../../self-disclosure-unique-fields.service';
import { COUNTRIES } from '../../../tokens/countries.injection-token';

@Component({
  selector: 'app-self-disclosure-address',
  templateUrl: './self-disclosure-address.component.html',
  styleUrls: ['./self-disclosure-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    AppInputDirective,
    FormFieldLabelComponent,
    FormFieldComponent,
    PhoneInputComponent,
    ImmomioSelect,
    ImmomioFormFieldComponent
  ]
})
export class SelfDisclosureAddressComponent implements OnInit, OnDestroy {
  private registry = inject(SelfDisclosureUniqueFieldsService);
  readonly selfDisclosureQuestion = input<SelfDisclosureQuestion>(undefined);
  readonly form = input<FormGroup>(undefined);
  public countryList = inject(COUNTRIES);

  public get getFormControl() {
    return this.form().get('answer') as FormGroup;
  }

  ngOnInit() {
    this.registry.register('email', this.getFormControl.get('email'));
    this.registry.register('phone', this.getFormControl.get('phone'));
  }

  ngOnDestroy() {
    this.registry.unregister('email', this.getFormControl.get('email'));
    this.registry.unregister('phone', this.getFormControl.get('phone'));
  }
}
